import { render } from "./AddUser.vue?vue&type=template&id=f9126d76"
import script from "./AddUser.vue?vue&type=script&lang=js"
export * from "./AddUser.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__